module.exports = __webpack_public_path__ + "media/components/common/formParts/icons/Link-2ebeb590b593b013413f8506a84c07c8.svg";